import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { WHY_CHOOSE } from '../../utils/constants';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';

const WhyChooseSection = () => {
  return (
    <section id="why-us" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left - Text */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
          >
            <motion.p
              className="text-brand-500 font-semibold text-sm uppercase tracking-wider mb-3"
              variants={fadeInUp}
            >
              Our Advantage
            </motion.p>
            <motion.h2
              className="text-3xl sm:text-4xl text-neutral-900 leading-tight mb-6"
              style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
              variants={fadeInUp}
            >
              Why InstruVia
            </motion.h2>
            <motion.p
              className="text-neutral-600 text-lg leading-relaxed"
              style={{ fontFamily: "'Livvic', sans-serif" }}
              variants={fadeInUp}
            >
              We bring together industry expertise, curated partnerships, and a consultative approach to help dental practices source equipment with confidence.
            </motion.p>
          </motion.div>

          {/* Right - Checklist */}
          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 gap-4"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
          >
            {WHY_CHOOSE.map((item, i) => (
              <motion.div
                key={i}
                className="flex items-start space-x-3 bg-neutral-50 rounded-xl p-4"
                variants={staggerItem}
              >
                <CheckCircle size={20} className="text-accent-teal flex-shrink-0 mt-0.5" />
                <span className="text-neutral-700 text-sm font-medium" style={{ fontFamily: "'Livvic', sans-serif" }}>{item}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;